module.exports = __webpack_public_path__ + "img/product_26.c89fc82.svg";